import injectCSS from "../../html/inject-css";
import { registerListener } from "../../html/register-listener";

/**
 * The section marker component can be given a label (usually just a number)
 * and its position relative to the single-wall-component can be adjusted
 * conveniently with the `left` and `top` properties.
 */
export class SectionMarker extends HTMLElement {

    label: string;

    constructor(label: string) {
        super();
        injectCSS(STYLESHEET);
        this.label = label;

        registerListener(this, 'mouseover', this.mouseover);
    }

    connectedCallback() {
        this.replaceChildren(this.label);
        this.style.display = 'none';
    }

    get left(): number {
        return Number(this.style.left.replace('px', ''));
    }
    set left(value: number) {
        // it's shifted left by 18px to center it
        this.style.left = `${value - 18}px`;
        if(this.style.left && this.style.top) {
            this.style.display = '';
        }
    }

    get top(): number {
        return Number(this.style.top.replace('px', ''));
    }
    set top(value: number) {
        // it's shifted up by 18px to center it
        this.style.top = `${value - 18}px`;
        if(this.style.left && this.style.top) {
            this.style.display = '';
        }
    }

    mouseover = (event: MouseEvent) => {
        this.dispatchEvent(new CustomEvent('markerover', {
            bubbles: true,
            detail: {
                markerLabel: this.label,
                event,
            }
        }));
    }
}
window.customElements.define('section-marker', SectionMarker);
export default SectionMarker

const STYLESHEET = `
section-marker {
    display: block;
    position: absolute;
    width: 36px;
    height: 36px;
    padding: 6px;
    background: #000;
    border: 2px solid #fff;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    font: 18px Arial, sans-serif;
}
`;
